import { BotId } from "../global/models/models";
import { MesosFeatureButtonId } from "./mesos-config";

interface FeatureButtonBase<B extends BotId, M extends MesosFeatureButtonId> {
    // Text shown to the user
    text: string;
    botId: B;
    // Payload, which is sent to the backend
    message: string;
    mesosId: M;
}

export type KugFeatureButton = FeatureButtonBase<
    "KUG",
    "enableKUGFreeText" | "enableKUGCalculator"
>;
export type AlgFeatureButton = FeatureButtonBase<
    "ALG",
    "enableALGFreeText" | "enableALGOtherTopics" | "enableALGLanding"
>;
export type BgeldFeatureButton = FeatureButtonBase<
    "BGELD",
    "enableBGFreeText" | "enableBGDecisionTree"
>;
export type FamkaFeatureButton = FeatureButtonBase<
    "FAMKA",
    "enableFamkaFreeText"
>;
export type SasFeatureButton = FeatureButtonBase<
    "SAS",
    "enableSASFreeText" | "enableSASConsultingText"
>;
export type WauFeatureButton = FeatureButtonBase<
    "WAU",
    "enableWAUFreeText"
>;
export type PinkFeatureButton = FeatureButtonBase<
    "PINK",
    | "enableNavigationFreeText"
    | "enableBewerbersucheFreeText"
    | "enableLeistungenFreeText"
    | "enableEinstellungenFreeText"
>;
export type FormFeatureButton = FeatureButtonBase<"FORM", "enableFormFreeText">;
export type InkassoFeatureButton = FeatureButtonBase<"INKASSO", "enableInkassoFreeText">;
export type KinFeatureButton = FeatureButtonBase<
    "KIN",
    "enableKinFreeText" | "enableKinDecisionTree"
>;
export type StartseiteFeatureButton = FeatureButtonBase<
    "STARTSEITE",
    "enableStartseiteFreeText"
>;

export type FeatureButton =
    | KugFeatureButton
    | AlgFeatureButton
    | BgeldFeatureButton
    | FamkaFeatureButton
    | KinFeatureButton
    | StartseiteFeatureButton
    | SasFeatureButton
    | WauFeatureButton
    | PinkFeatureButton
    | FormFeatureButton
    | InkassoFeatureButton;

export const KUG_CALCULATOR: KugFeatureButton = {
    text: "Kurzarbeitergeld berechnen",
    botId: "KUG",
    message: "/kug_start_calculator",
    mesosId: "enableKUGCalculator",
};
export const KUG_FREE_TEXT: KugFeatureButton = {
    text: "Fragen stellen",
    botId: "KUG",
    message: "/kug_start_at_freetext",
    mesosId: "enableKUGFreeText",
};

export const ALG_FREE_TEXT: AlgFeatureButton = {
    text: 'Fragen zum Thema Arbeitslosengeld stellen',
    botId: 'ALG',
    message: '/alg_start_domain_alg',
    mesosId: 'enableALGFreeText',
};
export const ALG_OTHER_TOPICS: AlgFeatureButton = {
    text: 'Fragen zu weiteren Themen stellen',
    botId: 'ALG',
    message: '/alg_start_domain_other',
    mesosId: 'enableALGOtherTopics',
};
export const ALG_LANDING_PAGE: AlgFeatureButton = {
    text: 'Fragen zum Thema Arbeitslosengeld und weiteren Themen stellen',
    botId: 'ALG',
    message: '/alg_start_landing_page',
    mesosId: 'enableALGLanding',
};


export const BGELD_FREE_TEXT: BgeldFeatureButton = {
    text: "Fragen zum Thema Bürgergeld stellen",
    botId: "BGELD",
    message: "/bgeld_start_at_freetext",
    mesosId: "enableBGFreeText",
};
export const BGELD_DECISION_TREE: BgeldFeatureButton = {
    text: "Anspruch prüfen",
    botId: "BGELD",
    message: "/bgeld_start_at_decisionTree",
    mesosId: "enableBGDecisionTree",
};

export const KIN_FREE_TEXT: KinFeatureButton = {
    text: "Kindergeld Fragen stellen",
    botId: "KIN",
    message: "/kin_start_at_freetext",
    mesosId: "enableKinFreeText",
};
export const KIN_DECISION_TREE: KinFeatureButton = {
    text: "Voraussetzungen Kindergeld",
    botId: "KIN",
    message: "/kin_start_at_decisionTree",
    mesosId: "enableKinDecisionTree",
};
export const KIZ_FREE_TEXT: FamkaFeatureButton = {
    text: "Kinderzuschlag Fragen stellen",
    botId: "FAMKA",
    message: "/famka_start_at_freetext",
    mesosId: "enableFamkaFreeText",
};

export const SAS_FREE_TEXT: SasFeatureButton = {
    text: "Fragen zu Ausbildung, Studium & Berufen stellen",
    botId: "SAS",
    message: "/sas_start_at_freetext",
    mesosId: "enableSASFreeText",
};
export const SAS_CONSULTING_TEXT: SasFeatureButton = {
    text: "Jetzt Beratungstermin anfragen",
    botId: "SAS",
    message: "/sas_glossar_4_berufsberatung",
    mesosId: "enableSASConsultingText",
};

export const FORM_FREE_TEXT_DE: FormFeatureButton = {
    text: "Weiter zum Fragebogen",
    botId: "FORM",
    message: "start_initial_form_dialogue_de",
    mesosId: "enableFormFreeText",
};

export const FORM_FREE_TEXT_UA: FormFeatureButton = {
    text: "Далі до анкети",
    botId: "FORM",
    message: "start_initial_form_dialogue_ua",
    mesosId: "enableFormFreeText",
};

export const FORM_INFO_TEXT_UA: FormFeatureButton = {
    text: "Інформація українською мовою",
    botId: "FORM",
    message: "change_language",
    mesosId: "enableFormFreeText",
};

export const FORM_ASSISTANT_DE: FormFeatureButton = {
    text: "Fragebogen starten →",
    botId: "FORM",
    message: "start_form_dialogue_de",
    mesosId: "enableFormFreeText",
};

export const FORM_ASSISTANT_UA: FormFeatureButton = {
    text: "Розпочати опитування →",
    botId: "FORM",
    message: "start_form_dialogue_ua",
    mesosId: "enableFormFreeText",
};

export const INKASSO_FREE_TEXT: InkassoFeatureButton = {
    text: "Fragen zu Inkasso-Service Themen stellen",
    botId: "INKASSO",
    message: "/inkasso_start_at_freetext",
    mesosId: "enableInkassoFreeText",
};

export const STARTSEITE_FREE_TEXT: StartseiteFeatureButton = {
    text: "Alle verfügbaren Themen",
    botId: "STARTSEITE",
    message: "/startseite_start_at_freetext",
    mesosId: "enableStartseiteFreeText",
};

export const NAVIGATION_FREE_TEXT: PinkFeatureButton = {
    text: "Überblick und Navigation",
    botId: "PINK",
    message: "/pink_start_at_overview",
    mesosId: "enableNavigationFreeText",
};

export const BEWERBERSUCHE_FREE_TEXT: PinkFeatureButton = {
    text: "Personalsuche",
    botId: "PINK",
    message: "/pink_start_at_applicant_search",
    mesosId: "enableBewerbersucheFreeText",
};

export const LEISTUNGEN_FREE_TEXT: PinkFeatureButton = {
    text: "Geldleistungen und andere Leistungen",
    botId: "PINK",
    message: "/pink_start_at_benefits",
    mesosId: "enableLeistungenFreeText",
};

export const EINSTELLUNGEN_FREE_TEXT: PinkFeatureButton = {
    text: "Einstellungen und Verwaltung",
    botId: "PINK",
    message: "/pink_start_at_settings_management",
    mesosId: "enableEinstellungenFreeText",
};

export const WAU_FREE_TEXT: WauFeatureButton = {
    text: "Fragen zu Ausbildung, Studium & Berufen stellen",
    botId: "WAU",
    message: "/wau_start_at_freetext",
    mesosId: "enableWAUFreeText",
};

export const SAS_BUTTONS = [SAS_FREE_TEXT, SAS_CONSULTING_TEXT];
export const WAU_BUTTONS = [WAU_FREE_TEXT];
export const FORM_DE_BUTTONS = [FORM_FREE_TEXT_DE, FORM_INFO_TEXT_UA];
export const FORM_UA_BUTTONS = [FORM_FREE_TEXT_UA];
export const FORMULAR_DE_BUTTONS = [FORM_ASSISTANT_DE];
export const FORMULAR_UA_BUTTONS = [FORM_ASSISTANT_UA];
export const INKASSO_BUTTONS = [INKASSO_FREE_TEXT];
export const FAMKA_BUTTONS = [KIN_FREE_TEXT, KIN_DECISION_TREE, KIZ_FREE_TEXT];
export const PINK_BUTTONS = [
    NAVIGATION_FREE_TEXT,
    BEWERBERSUCHE_FREE_TEXT,
    LEISTUNGEN_FREE_TEXT,
    EINSTELLUNGEN_FREE_TEXT,
];
export const STARTSEITE_BUTTONS = [STARTSEITE_FREE_TEXT];
export const KUG_BUTTONS = [KUG_CALCULATOR, KUG_FREE_TEXT];
export const ALG_BUTTONS = [ALG_FREE_TEXT, ALG_OTHER_TOPICS];
export const BGELD_BUTTONS = [BGELD_FREE_TEXT, BGELD_DECISION_TREE];

export const LS_FREE_TEXT = {
    botId: "LEICHTS",
    message: "/leichts_start_at_freetext",
} as const;
